import { useMemo } from 'react'

import { useOnboardingNaturesOfBusinessQuery } from '@shared/graphql'
import useTranslation from 'next-translate/useTranslation'

import { L3OnboardingDropdown } from '../../L3OnboardingDropdown'

import type { L3OnboardingDropdownVariantProps } from '../types'
import type { SelectListItem } from '@circlefin/components/lib/SelectList'

export const BusinessType: React.FC<L3OnboardingDropdownVariantProps> = (
  props,
) => {
  const { t } = useTranslation('l3Onboarding')

  const { data: natureOfBusinessList, loading } =
    useOnboardingNaturesOfBusinessQuery({
      variables: {
        input: {
          excludeProhibited: true,
        },
      },
    })

  const data: Array<SelectListItem<string>> = useMemo(
    () =>
      natureOfBusinessList?.onboardingNaturesOfBusiness.map((option) => ({
        label: option.name,
        value: option.value,
      })) ?? [],
    [natureOfBusinessList],
  )

  return (
    <L3OnboardingDropdown
      inputLoading={loading}
      items={data}
      label={t`forms.common.businessType.label`}
      {...props}
    />
  )
}
